import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {FieldType} from "../../fields3/field-type"
import FieldCompanyUserWorkdayDuration from "../../fields3/system/user/workday-duration/workday-duration"
import FieldToggle from "../../fields3/generic/boolean/toggle/toggle"
import {EntityType} from "../../gd/const/item"
import FieldDropdown from "../../fields3/generic/dropdown/dropdown";



const debug = false
// const debug = "WorkWeekScheduleFields"

export default class WorkWeekScheduleFields extends FieldsCollection {

    constructor(options:any = {}) {

        const weekStartOptions : any[] = [];
        _.map(['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'], (val,key)=>{
            weekStartOptions.push({
                label: moment().isoWeekday(key+1).format('dddd'),
                value: val
            });
        })

        const fieldsConfig = [
            {fieldId: 'mondayDuration',     type: FieldType.COMPANY_USER_WORKDAY_DURATION},
            {fieldId: 'tuesdayDuration',    type: FieldType.COMPANY_USER_WORKDAY_DURATION},
            {fieldId: 'wednesdayDuration',  type: FieldType.COMPANY_USER_WORKDAY_DURATION},
            {fieldId: 'thursdayDuration',   type: FieldType.COMPANY_USER_WORKDAY_DURATION},
            {fieldId: 'fridayDuration',     type: FieldType.COMPANY_USER_WORKDAY_DURATION},
            {fieldId: 'saturdayDuration',   type: FieldType.COMPANY_USER_WORKDAY_DURATION},
            {fieldId: 'sundayDuration',     type: FieldType.COMPANY_USER_WORKDAY_DURATION},
            {fieldId: 'isMondayWorking',    type: FieldType.TOGGLE},
            {fieldId: 'isTuesdayWorking',   type: FieldType.TOGGLE},
            {fieldId: 'isWednesdayWorking', type: FieldType.TOGGLE},
            {fieldId: 'isThursdayWorking',  type: FieldType.TOGGLE},
            {fieldId: 'isFridayWorking',    type: FieldType.TOGGLE},
            {fieldId: 'isSaturdayWorking',  type: FieldType.TOGGLE},
            {fieldId: 'isSundayWorking',    type: FieldType.TOGGLE},

            {
                fieldId             : 'weekStart',
                type                : FieldType.DROPDOWN,
                options             : weekStartOptions,
                addNoValueOption    : false,
                showMenuMore        : false,
                isSearchable        : false,
            }
        ]

        debug && console.log(debug, 'constructor', fieldsConfig)

        super(fieldsConfig, EntityType.DYNAMIC_MODEL)
    }

    get mondayDuration()        { return this.get('mondayDuration') as FieldCompanyUserWorkdayDuration }
    get tuesdayDuration()       { return this.get('tuesdayDuration') as FieldCompanyUserWorkdayDuration }
    get wednesdayDuration()     { return this.get('wednesdayDuration') as FieldCompanyUserWorkdayDuration }
    get thursdayDuration()      { return this.get('thursdayDuration') as FieldCompanyUserWorkdayDuration }
    get fridayDuration()        { return this.get('fridayDuration') as FieldCompanyUserWorkdayDuration }
    get saturdayDuration()      { return this.get('saturdayDuration') as FieldCompanyUserWorkdayDuration }
    get sundayDuration()        { return this.get('sundayDuration') as FieldCompanyUserWorkdayDuration }
    get isMondayWorking()       { return this.get('isMondayWorking') as FieldToggle }
    get isTuesdayWorking()      { return this.get('isTuesdayWorking') as FieldToggle }
    get isWednesdayWorking()    { return this.get('isWednesdayWorking') as FieldToggle }
    get isThursdayWorking()     { return this.get('isThursdayWorking') as FieldToggle }
    get isFridayWorking()       { return this.get('isFridayWorking') as FieldToggle }
    get isSaturdayWorking()     { return this.get('isSaturdayWorking') as FieldToggle }
    get isSundayWorking()       { return this.get('isSundayWorking') as FieldToggle }

    get weekStart()             { return this.get('weekStart') as FieldDropdown }
}
